import React from "react";
import { useLocalStorage } from "@adsk/acc-issues-core/utils/hooks/useLocalStorage";
import { LocalStorageKeys } from "@adsk/acc-issues-core/state/localStorage";
import {
  trackCollapseExpandClose,
  trackCollapseExpandOpen,
} from "../utils/analytics/collapseExpandTracking";

export const useShouldExpandEmptyFieldsAccordion = (): [
  boolean,
  (value: boolean) => void
] => {
  const [get, set] = useLocalStorage(
    LocalStorageKeys.LAST_COLLAPSIBLE_SECTION_STATE_IS_OPEN
  );
  const storedValue = get() ?? false;

  const [isExpandState, setStateIsExpanded] =
    React.useState<boolean>(storedValue);

  const setIsExpanded = React.useCallback(
    (isExpanded: boolean) => {
      isExpanded ? trackCollapseExpandOpen() : trackCollapseExpandClose();
      setStateIsExpanded(isExpanded);
      set(isExpanded);
    },
    [set]
  );

  return [isExpandState, setIsExpanded];
};
